import * as React from 'react'
import {Component, Fragment} from 'react'
import {findDOMNode} from 'react-dom'
import {inject} from 'mobx-react'
import {WidgetApi} from '../../lib/WidgetApi'

///////////////////////////////////////////////////////////////////////////////

export type RippleWrapperProps = {
  api?: WidgetApi
  children?: any
  disabled?: boolean
}

///////////////////////////////////////////////////////////////////////////////

@inject('api')
export class RippleWrapper extends Component<RippleWrapperProps, any> {
  private el: HTMLElement
  private rippleCont: HTMLElement

  public static defaultProps: Partial<RippleWrapperProps> = {
    disabled: false,
  }

  constructor(props) {
    super(props)

    this.onClick = this.onClick.bind(this)
  }

  componentDidMount() {
    let uiRippleEffects = this.props.api.computedConfig.uiRippleEffects

    if (!uiRippleEffects || this.props.disabled) {
      return
    }

    this.el = findDOMNode(this) as HTMLElement

    if (this.el) {
      this.rippleCont = document.createElement('div')
      this.rippleCont.classList.add('md-ripple-cont')
      this.rippleCont.addEventListener('click', this.onClick)

      this.el.classList.add('md-ripple')
      this.el.appendChild(this.rippleCont)
    }
  }

  componentDidUpdate() {
    if (this.el) {
      this.el.classList.add('md-ripple')
    }
  }

  componentWillUnmount() {
    if (this.rippleCont) {
      this.rippleCont.removeEventListener('click', this.onClick)
    }
  }

  render() {
    return <Fragment>{this.props.children}</Fragment>
  }

  onClick(e) {
    let {uiTransitionTimeout: timeout} = this.props.api.computedConfig

    let rect = this.rippleCont.getBoundingClientRect()
    let size = rect.height
    let xPos = e.pageX - rect.left - window.scrollX
    let yPos = e.pageY - rect.top - window.scrollY

    let rippleEf = document.createElement('div')
    rippleEf.classList.add('md-ripple-effect')
    rippleEf.style.height = size + 'px'
    rippleEf.style.width = size + 'px'
    rippleEf.style.top = yPos - size / 2 + 'px'
    rippleEf.style.left = xPos - size / 2 + 'px'

    this.rippleCont.appendChild(rippleEf)

    setTimeout(() => {
      this.rippleCont.removeChild(rippleEf)
    }, timeout)
  }
}
